export const FETCH_PREORDER_BOOKS_REQUEST = "FETCH_PREORDER_BOOKS_REQUEST";
export const FETCH_PREORDER_BOOKS_SUCCESS = "FETCH_PREORDER_BOOKS_SUCCESS";
export const FETCH_PREORDER_BOOKS_FAIL = "FETCH_PREORDER_BOOKS_FAIL";

export const FETCH_BOOK_REQUEST = "FETCH_BOOK_REQUEST";
export const FETCH_BOOK_SUCCESS = "FETCH_BOOK_SUCCESS";
export const FETCH_BOOK_FAIL = "FETCH_BOOK_FAIL";
export const RESET_BOOK = "RESET_BOOK";

export const BOOK_ORDER_REQUEST = "BOOK_ORDER_REQUEST";
export const BOOK_ORDER_SUCCESS = "BOOK_ORDER_SUCCESS";
export const BOOK_ORDER_FAIL = "BOOK_ORDER_FAIL";
export const RESET_BOOK_ORDER = "RESET_BOOK_ORDER";

export const FETCH_ORDERS_REQUEST = "FETCH_ORDERS_REQUEST";
export const FETCH_ORDERS_SUCCESS = "FETCH_ORDERS_SUCCESS";
export const FETCH_ORDERS_FAIL = "FETCH_ORDERS_FAIL";
export const FETCH_ORDERS_RESET = "FETCH_ORDERS_RESET";

export const ADD_BOOK_REQUEST = "ADD_BOOK_REQUEST";
export const ADD_BOOK_SUCCESS = "ADD_BOOK_SUCCESS";
export const ADD_BOOK_FAIL = "ADD_BOOK_FAIL";
export const ADD_BOOK_RESET = "ADD_BOOK_RESET";

export const FETCH_WALLET_FAIL = "FETCH_WALLET_FAIL";
export const FETCH_WALLET_REQUEST = "FETCH_WALLET_REQUEST";
export const FETCH_WALLET_SUCCESS = "FETCH_WALLET_SUCCESS";

export const UPDATE_BOOK_SUCCESS = "UPDATE_BOOK_SUCCESS";
export const UPDATE_BOOK_FAIL = "UPDATE_BOOK_FAIL";

export const FETCH_CUSTOMER_ARTICLES_REQUEST =
  "FETCH_CUSTOMER_ARTICLES_REQUEST";
export const FETCH_CUSTOMER_ARTICLES_SUCCESS =
  "FETCH_CUSTOMER_ARTICLES_SUCCESS";
export const FETCH_CUSTOMER_ARTICLES_FAIL = "FETCH_CUSTOMER_ARTICLES_FAIL";

export const FETCH_MEMBER_ADCARDS_FAIL = "FETCH_MEMBER_ADCARDS_FAIL";
export const FETCH_MEMBER_ADCARDS_SUCCESS = "FETCH_MEMBER_ADCARDS_SUCCESS";
export const FETCH_MEMBER_ADCARDS_REQUEST = "FETCH_MEMBER_ADCARDS_REQUEST";

export const PROMOTED_BY = "PROMOTED_BY";
export const RESET_PROMOTED_BY = "RESET_PROMOTED_BY";
